import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import logo from "../../images/cooktop_logo.png";
import Spinner from "../../components/ui/Spinner";
import Button from "../../components/ui/Button";

const LoginComponent = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  const invitation = searchParams.get("invitation");
  const organization = searchParams.get("organization");

  const triggerLogin = () =>
    loginWithRedirect({
      ...(invitation && {
        authorizationParams: { invitation, organization },
      }),
    });

  useEffect(() => {
    if (!isAuthenticated) {
      triggerLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface text-white px-6">
      <div className="w-full max-w-md flex flex-col items-center text-center gap-8">
        <img src={logo} alt="Cooktop Safety" className="h-16 w-auto" />
        <h1 className="text-2xl font-semibold tracking-wide">
          Welcome to the Cooktop Safety Dashboard
        </h1>
        <p className="text-ink-3 text-sm">
          Redirecting you to a secure sign-in…
        </p>
        <Spinner size={64} />
        <Button variant="ghost" size="sm" onClick={triggerLogin}>
          Continue to Login
        </Button>
      </div>
    </div>
  );
};

export default LoginComponent;
